import PropTypes from "prop-types";

import styled from "styled-components/macro";

import PaymentTypeHandler from "Giving/ManageMyGivingPage/PaymentTypeHandler";

TooltipContent.propTypes = {
  status: PropTypes.string,
  failedPaymentsCount: PropTypes.number,
  paymentType: PropTypes.string,
};

export default function TooltipContent({
  status,
  failedPaymentsCount,
  paymentType,
}) {
  const paymentTypeHandler = new PaymentTypeHandler(paymentType);

  const title =
    status === "paused"
      ? `${paymentTypeHandler.plural(true)} Paused`
      : status === "stopped"
      ? `${paymentTypeHandler.plural(true)} Stopped`
      : status === "active" && failedPaymentsCount === 1
      ? `Failed ${paymentTypeHandler.capitalized()}`
      : "";

  return (
    <Content>
      <Message>
        {title}
        <ClickForDetails>(click for details)</ClickForDetails>
      </Message>
    </Content>
  );
}

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
`;

const Message = styled.div``;

const ClickForDetails = styled.span`
  display: inline-block;
  margin-left: 5px;
  font-size: 13px;
  opacity: 0.8;
`;
